import { AfterViewChecked, AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { EventManager } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TweenMax, Power3 } from "gsap";
import { ConfigService } from '../services/config.service';

@Component({
  selector: 'app-topannonce-bis',
  templateUrl: './topannonce-bis.component.html',
  styleUrls: ['./topannonce-bis.component.css']
})
export class TopannonceBisComponent implements OnInit, AfterViewInit, AfterViewChecked {

  @Input() annonces!: AnnonceLite[];
  public error: string;
  public isMobile = false;
  config = ConfigService.GetItem;

  @Input() charger!: boolean;

  constructor(private router: Router, private eventManager: EventManager) {
    this.eventManager.addGlobalEventListener('window', 'resize', this.OnResize.bind(this));
  }

  ngOnInit(): void {
    if (window.screen.width >= 1025) {
      this.isMobile = false;
    }
    else
      this.isMobile = true;
  }

  ngAfterViewInit(): void {
    var cards;
    if (this.isMobile) {
      cards = $('#card-slider .slider-item-mobile').toArray()
    } else {
      cards = $('#card-slider .slider-item').toArray()
    }
    
    this.startAnim(cards);
    this.charger = true;
  }

  ngAfterViewChecked() {
    if (window.screen.width >= 1025) {
      this.isMobile = false;
    }
    else
      this.isMobile = true;
  }

  private OnResize(event: any) {
    if (window.screen.width >= 1025) {
      this.isMobile = false;
    }
    else
      this.isMobile = true;
    //this.mapComponent.resize();
  }

  public startAnim(array) {
    if (array.length >= 4) {
      if (this.isMobile) {
        TweenMax.fromTo(array[0], 0.5, { x: 0, y: 0, opacity: 0.75 }, { x: -300, y: 0, opacity: 0, zIndex: 0, delay: 0.03, ease: Power3.easeInOut, onComplete: this.sortArray(array) });

        TweenMax.fromTo(array[1], 0.5, { x: 500, y: 0, opacity: 1, zIndex: 1 }, { x: 0, y: 0, opacity: 1, zIndex: 0, boxShadow: '-5px 8px 8px 0 rgba(82,89,129,0.05)', ease: Power3.easeInOut });
      } else {
        TweenMax.fromTo(array[0], 0.5, { x: 0, y: 0, opacity: 0.75 }, { x: 0, y: -300, opacity: 0, zIndex: 0, delay: 0.03, ease: Power3.easeInOut, onComplete: this.sortArray(array) });

        TweenMax.fromTo(array[1], 0.5, { x: 0, y: 150, opacity: 1, zIndex: 1 }, { x: 0, y: 0, opacity: 0.75, zIndex: 0, boxShadow: '-5px 8px 8px 0 rgba(82,89,129,0.05)', ease: Power3.easeInOut });

        TweenMax.fromTo(array[2], 0.5, { x: 0, y: 300, opacity: 0.75, zIndex: 0 }, { x: 0, y: 150, boxShadow: '-5px 8px 8px 0 rgba(82,89,129,0.05)', zIndex: 1, opacity: 1, ease: Power3.easeInOut });

        TweenMax.fromTo(array[3], 0.5, { x: 0, y: 600, opacity: 0, zIndex: 0 }, { x: 0, y: 300, opacity: 0.75, zIndex: 0, ease: Power3.easeInOut },);
      }
    } else if (array.length >= 3) {
      TweenMax.fromTo(array[0], 0.5, { x: 0, y: 0, opacity: 0.75 }, { x: 0, y: -120, opacity: 0, zIndex: 0, delay: 0.03, ease: Power3.easeInOut, onComplete: this.sortArray(array) });
      TweenMax.fromTo(array[1], 0.5, { x: 0, y: 150, opacity: 1, zIndex: 1 }, { x: 0, y: 0, opacity: 0.75, zIndex: 0, boxShadow: '-5px 8px 8px 0 rgba(82,89,129,0.05)', ease: Power3.easeInOut });
      TweenMax.fromTo(array[2], 0.5, { x: 0, y: 300, opacity: 0.75, zIndex: 0 }, { x: 0, y: 150, boxShadow: '-5px 8px 8px 0 rgba(82,89,129,0.05)', zIndex: 1, opacity: 1, ease: Power3.easeInOut });
    } else if (array.length >= 2) {
      TweenMax.fromTo(array[0], 0.5, { x: 0, y: 0, opacity: 0.75 }, { x: 0, y: 150, opacity: 0.75, zIndex: 0, delay: 0.03, ease: Power3.easeInOut, onComplete: this.sortArray(array) });
      TweenMax.fromTo(array[1], 0.5, { x: 0, y: 150, opacity: 1, zIndex: 1 }, { x: 0, y: 0, opacity: 0.75, zIndex: 0, boxShadow: '-5px 8px 8px 0 rgba(82,89,129,0.05)', ease: Power3.easeInOut });
    } else if (array.length >= 1) {
      TweenMax.fromTo(array[0], 0.5, { x: 0, y: 150, opacity: 1, zIndex: 1 }, { x: 0, y: 0, opacity: 1, zIndex: 0, boxShadow: '-5px 8px 8px 0 rgba(82,89,129,0.05)', ease: Power3.easeInOut });
    }
  }

  sortArray(array): any {
    clearTimeout(delay);
    var delay = setTimeout(() => this.test(array), 3000);
  }

  test(array) {
    var firstElem = array.shift();
    array.push(firstElem);
    return this.startAnim(array);
  }

  public goToAnnonce(id) {
    this.router.navigate(['annonce-read'], { queryParams: { id: id } });
  }
  lowText(text, length): string {
    if (text && text.length > length)
      return text.substr(0, length).replace(/<(?:.|\n)*?>/gm, '').replace('&nbsp;', ' ') + '...';
    return text.replace(/,/gm, '');
  }
}

interface AnnonceLite {
  idannonce: number;
  intitule: string;
  emp_adresse1: string;
  emp_code_postal: string;
  emp_ville: string;
  contrats: string;
  societe_adresse: string;
  societe_cp: string;
  societe_ville: string;
  societe_logo: string;
  ref: string;
  previsu: string;
  niveau_formation: string;
  regions: string;
  caract_poste: string;
}
